import { Phase } from 'components/common/LoadingSteps/LoadingSteps';

export const NARRATIVE_PHASES: Phase[] = [
    // Phase 1 - 4s
    { header: 'Reading your project data', text: 'Interpreting the latest available project information...', duration: 4000 },
    // Phase 2 - 4s (total 8s)
    { header: 'Reading your project data', text: 'Gathering relevant data from this report...', duration: 4000 },
    // Phase 3 - 6s (total 14s)
    { header: 'Identifying what matters most', text: 'Filtering out noise to surface key signals...', duration: 6000 },
    // Phase 4 - 6s (total 20s)
    { header: 'Identifying what matters most', text: 'Focusing on areas with the greatest impact...', duration: 6000 },
    // Phase 5 - 7s (total 27s)
    { header: 'Tailoring the narrative for this report', text: 'Adapting tone and focus...', duration: 7000 },
    // Phase 6 - 7s (total 34s)
    { header: 'Tailoring the narrative for this report', text: 'Shaping content to fit the right needs...', duration: 7000 },
    // Phase 7 - 5s (total 39s)
    { header: 'Writing the narrative', text: 'Turning analysis into a clear explanation...', duration: 5000 },
    // Phase 8 - 5s (total 44s)
    { header: 'Writing the narrative', text: 'Drafting a concise, readable summary...', duration: 5000 },
    // Phase 9 - 6s (total 50s)
    { header: 'Finalising and checking consistency', text: 'Ensuring the narrative reflects the underlying data...', duration: 6000 },
    // Phase 10 - 6s (total 56s)
    { header: 'Finalising and checking consistency', text: 'Checking for clarity and consistency...', duration: 6000 },
    // Phase 11 - 10s (total 66s)
    { header: 'Finalising and checking consistency', text: 'This may take a little longer for larger and more complex schedules...', duration: 10000 },
    // Phase 12 - indefinite
    { header: 'Finalising and checking consistency', text: 'Final checks in progress...', duration: -1 },
];
